module.exports = __webpack_public_path__ + "img/logo-zh.b6f9f56e.png";